import React, { Component } from "react";
import Serverurl from './Apiurl';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  

import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  

import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { Navigate  } from 'react-router-dom';

import FormControl from '@mui/material/FormControl';
import {InputLabel } from '@mui/material';
import Select from '@mui/material/Select';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
  const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default class Groupweekclasses extends Component {

   constructor(props) {
      super(props);
	  this.state = {slotData:[],Branchdata:[],branchid:'',weekday:'Monday',weekval:'0',sltid:0,slotname:'',giid:0}
	    this.updateDonenewParent = this.updateDonenewParent;
   }
   
    
  	componentWillMount() {
		document.title = "AthaYog Living - Staff Management";
		if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Default'
          })
		  }
		  
	this.onloadBranch();		  
	
 
	}
	updateDonenewParent = (text) => { this.onloadslot(); }
onloadslot(){
		
		axios.post(Serverurl+'ajaxgroupintence.php?action=groupsclassestitle&sm_slottype=3&sorting=sm_order&sm_bm_id='+this.state.branchid)
  .then(resp => {  
		
  if(resp.data.length>0){				
		this.setState({slotData:resp.data},()=>{
		     
		
       
								
		})
	
		}else{this.setState({slotData:[]});
		 }
 
    });
		
	} 
	
	onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid="";

								
									strbrid=resp.data[0]["bm_id"];
								
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
	
        this.setState({branchid:strbrid,
          Branchdata: BranchFromApi
        },()=>{	
		
		this.onloadslot();		});
								
							})


					
  }else{
	  this.setState({Branchdata:[]});
  }
   
  });
	
}
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
   

  this.setState({[nam]: val},()=>{
	  if(nam==="branchid")
	  {
	  this.onloadslot();
	  }	  
  });

}
	handleWeeklySchedule (slot,val,id){		
		this.setState({ sltid: id,slotname:slot,weekval:val,giid:0 },()=>{	
		  this.refs.Weeksclass.handleClickOpen();
		   }); 
	}
	handleWeeklyEditSchedule (slot,val,id,giid){

this.setState({ sltid: id,slotname:slot,weekval:val,giid:giid },()=>{
	
		  this.refs.Weeksclass.handleClickOpen();
		   }); 


	}
render() {
		if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
   <React.Fragment>
   <div className="boxheading">				  
<h2>Group Weekly Classes</h2>
</div>
<div className="clear"></div>
   <div className="searchmaster">
   <ul>
   
    <li>
<p>Select Branch</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>

</ul></div>
<Weeksclass ref="Weeksclass" val={this.state.weekval} giid={this.state.giid} slotname={this.state.slotname} smid={this.state.sltid}  updateDonenew={this.updateDonenewParent}/>
   <Paper >


  <TableContainer >  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
<TableCell>                                     
         
				 </TableCell>
				 <TableCell>                                     
      Monday
				 </TableCell>
          <TableCell>                                     
       Tuesday   
				 </TableCell>	
 <TableCell> Wednesday                                   
         
				 </TableCell> <TableCell>                                     
  Thursday 
				 </TableCell><TableCell>                                     
         Friday   
				 </TableCell><TableCell>                                     
        Saturday   
				 </TableCell><TableCell>                                     
        Sunday   
				 </TableCell>
				 
                      </TableRow></TableHead>
					  
					  
                      <TableBody>
                     {this.state.slotData.map((item,index) => { 
			
           return (
 <React.Fragment>
 <TableRow key={index} >

 <TableCell>
 {item.sm_slotname}
 </TableCell>
 
 <TableCell>
  
   {item.customer1.length>0 &&(
  <ul className="submembers">
   {item.customer1.map((col1,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,0,col1.gi_sm_id,col1.gi_id)}}><h4>{col1.gi_title}</h4>
  <img src={Serverurl+"uploads/"+col1.gi_image} width="70px" alt="AthaYog"/>
  {col1.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col1.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>
  
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}

  {item.customer1.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,0,item.sm_id)}}/>
  
 </React.Fragment>	
  )}
 </TableCell>
 <TableCell>
  
   {item.customer2.length>0 &&(
  <ul className="submembers">
   {item.customer2.map((col2,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,1,col2.gi_sm_id,col2.gi_id)}}><h4>{col2.gi_title} </h4>
  <img src={Serverurl+"uploads/"+col2.gi_image} width="70px" alt="AthaYog"/>  {col2.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col2.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>
 
   </React.Fragment>	
);
  })}
  </ul>
  
  )}

  {item.customer2.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,1,item.sm_id)}}/>
  
 </React.Fragment>	
  )}
 </TableCell>
 

  <TableCell>
  {item.customer3.length>0 &&(
  <ul className="submembers">
   {item.customer3.map((col3,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,2,col3.gi_sm_id,col3.gi_id)}}><h4>{col3.gi_title}</h4>
  <img src={Serverurl+"uploads/"+col3.gi_image} width="70px" alt="AthaYog"/>{col3.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col3.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  {item.customer3.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,2,item.sm_id)}}/>
 </React.Fragment>	
  )}
 </TableCell>
  <TableCell> 
  
   {item.customer4.length>0 &&(
  <ul className="submembers">
   {item.customer4.map((col4,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,3,col4.gi_sm_id,col4.gi_id)}}><h4>{col4.gi_title} </h4>
  <img src={Serverurl+"uploads/"+col4.gi_image} width="70px" alt="AthaYog"/>{col4.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col4.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
 {item.customer4.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,3,item.sm_id)}}/>
   </React.Fragment>	
  )}
  
 </TableCell>
  <TableCell>
  
   {item.customer5.length>0 &&(
  <ul className="submembers">
   {item.customer5.map((col5,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,4,col5.gi_sm_id,col5.gi_id)}}><h4>{col5.gi_title}</h4>
  <img src={Serverurl+"uploads/"+col5.gi_image} width="70px" alt="AthaYog"/> 
  {col5.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col5.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  

  {item.customer5.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,4,item.sm_id)}}/>
  
 </React.Fragment>	
  )}
 </TableCell>
  <TableCell>
  
   {item.customer6.length>0 &&(
  <ul className="submembers" >
   {item.customer6.map((col6,i) => { 
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,5,col6.gi_sm_id,col6.gi_id)}}><h4>{col6.gi_title}</h4>
  <img src={Serverurl+"uploads/"+col6.gi_image} width="70px" alt="AthaYog"/> {col6.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col6.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>
  
   </React.Fragment>	
);
  })}
  </ul>
  
  )}
  {item.customer6.length===0 && ( <React.Fragment>
  <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,5,item.sm_id)}}/>
   </React.Fragment>	
  )}
 </TableCell>
 <TableCell>
 
 {item.customer7.length>0 &&(
  <ul className="submembers" >
   {item.customer7.map((col7,row) => { 
  
   return (
 <React.Fragment>
  <li onClick={()=>{this.handleWeeklyEditSchedule(item.sm_slotname,6,col7.gi_sm_id,col7.gi_id)}}><h4>{col7.gi_title}</h4>
  <img src={Serverurl+"uploads/"+col7.gi_image} width="70px" alt="AthaYog"/> 
    {col7.gi_color!="" &&(
 <div
    style={{
      width: '20px',
      height: '20px',
      backgroundColor: col7.gi_color,
      border: '1px solid #ccc',
      borderRadius: '15px',
      marginTop: '5px'
    }}
  ></div>
  )}</li>

   </React.Fragment>	
);
  })}
  </ul>
  
  )} {item.customer7.length===0 && ( <React.Fragment>
 <AddIcon className="staffschedbtn" onClick={()=>{this.handleWeeklySchedule(item.sm_slotname,6,item.sm_id)}}/>
    </React.Fragment>	
  )}
 </TableCell>
 
 
 </TableRow>

 </React.Fragment>		
);
					})}
					
					
                      </TableBody>


</Table>
  </TableContainer> 
  
  </Paper>
 </React.Fragment>

		  );
  }	
   
   
  
  
  
  
	
} 

export  class  Weeksclass extends Component {
	
	 constructor(props) {
	   super(props)	
		
		 this.state = {open:false,grptitle:'',grpimg:'',grpweekval:'',previocn:'',erropen:false,errormessage:'',grpsmid:'',grpweeknam:'',alertype:"error",grpbtndisable:false,btngroup:'Save',color:''}
		 
	 }
	 handleClickOpen = (e) => {
		 let strweekname="";
		 if(this.props.val===0)
		 {
			 strweekname="Monday";
		 }
		 if(this.props.val===1)
		 {
			 strweekname="Tuesday";
		 }
		  if(this.props.val===2)
		 {
			 strweekname="Wednesday";
		 }
		  if(this.props.val===3)
		 {
			 strweekname="Thursday";
		 }
		  if(this.props.val===4)
		 {
			 strweekname="Friday";
		 }
		 if(this.props.val===5)
		 {
			 strweekname="Saturday";
		 }
		 if(this.props.val===6)
		 {
			 strweekname="Sunday";
		 }
		 this.setState({open:true,grpweekval:this.props.val,grpsmid:this.props.smid,grpweeknam:strweekname});
		 
		 if(this.props.giid!==0)
  {

	  
	   axios.get(Serverurl+'ajaxgroupintence.php?action=getall&gi_id='+this.props.giid)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      grptitle:resp.data[0].gi_title,
	  previocn: resp.data[0].gi_image,
	  color:resp.data[0].gi_color,
       
    });
	
  }
  
});
	  
  }else{
	  this.setState({ 
     
      grptitle:'',
	  previocn: '',
	  color:'',
       
    });
  }
	 }
	myChangeHandler = (event) => {	
	 	let nam = event.target.name;
		let val = event.target.value;  
 		this.setState({[nam]: val});
	}
		 
	handleErrorclose=(event)=>{	  
		this.setState({erropen: false});  
	} 	
	onFileChange=(e) =>{	 
		let imageFile = e.target.files[0];
		this.setState({ grpimg: e.target.files })
		   
		if (!imageFile.name.match(/\.(png|jpeg|jpg)$/)) {

		    this.setState({errormessage:"Please Upload Valid banner (png,jpeg,jpg).",open:true});
			window.scrollTo({        top: 0     })
		  
			return false;
		}else{
			this.setState({ grpimg: e.target.files })
		}
  		
    }
	handleClickClose= (e) => { this.setState({open:!this.state.open,}); } 
handleSave=(event)=>{
	
	let grptitle=this.state.grptitle;
	let grpimg=this.state.grpimg;
	let color=this.state.color;
	let grpsmid=this.state.grpsmid;
	let grpweekval=this.state.grpweekval;
if(grptitle==="")
{
	
	this.setState({errormessage:"Please Enter  Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(grpimg==="" && this.state.previocn==="")
{
	
	this.setState({errormessage:"Please Upload Image",erropen:true});
		 window.scrollTo({       top: 0
      })
		 return false;
		
}
if(color==="")
{
	
	this.setState({errormessage:"Please Select the color",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
this.setState({errormessage:"",erropen:false,btngroup:"Processing...",grpbtndisable:true});

	var formData = new FormData();
formData.append('action','insertupdate') 
formData.append('gi_id',this.props.giid)
formData.append('gi_title',grptitle)
formData.append('gi_color',color)
formData.append('userid',localStorage.getItem("AYLuserid"))
    if(grpimg!=="")
	{		
		for (const key of Object.keys(this.state.grpimg)) {
		formData.append('Filedata', this.state.grpimg[key])
		}
 	formData.append('gi_image','1')		
	}else{
	formData.append('gi_image',this.state.previocn)	  
	}
	 formData.append('gi_sm_id',grpsmid)
	
    formData.append('gi_weekdays',grpweekval)
    axios.post(Serverurl+"ajaxgroupintence.php", formData, {
        }).then(res => {
				if(res.data!==0)
			{ 
 this.props.updateDonenew();
 this.setState({open:false,grpimg:'',grptitle:'',color:'',btngroup:"Save",grpbtndisable:false});
			}
		})			
}


render (){

return(
<React.Fragment>
 <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	   {this.state.grpweeknam}, {this.props.slotname} 
	  </DialogTitle>
      <DialogContent>
	
	  <p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  <p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="grptitle" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.grptitle}
			 
		
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
		
	
	
	
	
	
	
		<p>  <div className="uploadbtn">	  
		  

	<Button component="label"  className="iconuploadbtn" name="grpimg"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<CloudUploadIcon />}>
	
		Uplaod Image
		<VisuallyHiddenInput type="file"   /></Button>
		
		{this.state.previocn!=="" &&(
			<p><img src={Serverurl+'uploads/'+this.state.previocn} alt="AthaYog" target='_blank' style={{'width':'90px'}}/></p>
	
			)}

	</div></p>
		   
		<div> 
		
		</div>
		   
		
				
	<FormControl fullWidth className="txtbox">
  <Select
    native
    variant="outlined"
    inputProps={{ name: "color", id: "color" }}
    value={this.state.color}
    onChange={this.myChangeHandler}
    className="txtbox"
  >
    <option value="">Select Color</option>
    <option value="#00FF00">Green</option>
    <option value="#FF0000">Red</option>
    <option value="#0000FF">Blue</option>
    <option value="#FFA500">Orange</option>
  </Select>
</FormControl>




		
		
		
 <div className="actionbtn">
 
<div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleSave} disable={this.state.grpbtndisable}  className="frmSecondarybtn">
			{this.state.btngroup}
        </Button>
		</div>
<div className="clear"></div>	
	 
	 	</div>
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 

  





